<template>
  <div>
    <v-card class='mx-2' outlined>
      <v-card-title>
        <v-container fluid>
          Door Status
          <v-row>
            <v-col cols="12" sm="2" md="1" class="mt-2">
              <span><h5>Filters:</h5></span>
            </v-col>
            <v-col cols="12" sm="6" md="2" xl="1">
              <v-select
                v-model="filterGateways"
                @change="saveFilters"
                :items="['true','false']"
                label="GW Connection"
                clearable
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="2" xl="1">
              <v-select
                v-model="filterEnable"
                @change="saveFilters"
                :items="['true','false']"
                label="Enabled"
                clearable
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="3" xl="3">
              <v-select
                v-model="filterConnected"
                @change="saveFilters"
                :items="connectedStates"
                multiple
                label="Device Connected"
                dense
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="2" xl="2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search (incl hidden cols)"
                single-line
                hide-details
                clearable
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-data-table v-model="selected" 
        :headers="headers" 
        :items="doors" 
        :search="search" 
        show-select
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @update:sort-by="saveSort"
        @update:sort-desc="saveSort"
        :items-per-page='parseInt("100")'
        :footer-props="footerOptions"
        no-data-text="No Documents">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-btn 
              color="primary" 
              class="mt-n6"
              @click="editColumns">
              Edit Cols
            </v-btn>
            <v-dialog 
              v-model="showEditColDialog" 
              max-width="50%">
              <v-card class="px-4">
                <v-card-title>
                  <span class="headline">Select Columns to Show</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                  <v-select
                    v-model="selectedColumns"
                    :items="headers"
                    multiple
                    @change="changeColumns">
                  </v-select>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="primary" @click="editColumns">Ok</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-btn 
              color="primary" 
              class="mt-n6"
              :disabled='selected.length===0'
              @click="exportDoors">
              <v-icon left>
                fa-file-excel-o
              </v-icon>
                Export
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.devGwSerNum="{ item }">
          <span v-html=item.devGwSerNum :style="getGwColor(item.devGwConnected)"></span>
        </template>
        <template v-slot:item.doorEnabled="{ item }">
          <span v-html=item.doorEnabled :style="getDevEnabledColor(item.devGwConnected, item.doorEnabled)"></span>
        </template>
        <template v-slot:item.devConnected="{ item }">
          <span v-html=item.devConnected :style="getDevConnectedColor(item.devGwConnected, item.doorEnabled, item.devConnected)"></span>
        </template>
        <template v-slot:item.doorStatus="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                  <v-chip
                    :color="getStreamColor(item.doorStatus)"
                    :style="item.devGwConnected && item.doorEnabled? '' : 'opacity: 0.3'"
                    dark
                    small
                    v-on="on"
                  >
                    {{ item.doorStatus }}
                  </v-chip>
            </template>
            <span v-html=item.tooltip></span>
          </v-tooltip>
        </template>
       </v-data-table>
    </v-card>
  </div>
</template>

<script>

import { saveAs } from 'file-saver';

export default {
  name: "Doors",
  props: {
    app: Object,
    setProgressVal: Function,
    setProgressLinear: Function,
  },
  data: () => ({
    sortBy: "devGwSerNum",
    sortDesc: false,
    search: '',
    devices: [],
    doors: [],
    events: [],
    selected: [],
    selectedColumns: [],
    showEditColDialog: false,
    lastMotionCtr: 0,
    streamEventIdx: 0,
    eventDuration: 0,   // shared between motion and stream events queries
    cloudStatsIdx: 0,
    filterGateways: '',
    filterEnable: '',
    //Read from eventTypes(where: {type: {_eq: \"DeviceConnection\"}}) {statusValues {value}}
    connectedStates: ['Connected','Connecting','Disconnected','InvalidCredentials','NotSupported','Rebooting'],
    filterConnected: ['Connected','Connecting','Disconnected','InvalidCredentials','NotSupported','Rebooting'],
    footerOptions: {
      itemsPerPageOptions: [20, 50, 100, 200, 500, -1]
    }
  }),

  created() {
    console.log('Doors created')
  },

  mounted() {
    console.log('Doors mounted')
    this.initialize();
    let item = sessionStorage.getItem('doorsGatewayFilter');
    if (item) this.filterGateways = item;
    item = sessionStorage.getItem('doorsEnableFilter');
    if (item) this.filterEnable = item;
    item = sessionStorage.getItem('doorsConnectedFilter');
    if (item) this.filterConnected = item.split(",");
    item = sessionStorage.getItem("doorsSortBy"); 
    if (item) this.sortBy = item;
    item = sessionStorage.getItem("doorsSortDesc"); 
    if (item) this.sortDesc = item === 'true';
  },

  computed: {
    headers() {
      return [
      {
        text: 'Gateway',
        align: 'left',
        value: 'devGwSerNum',
      },
      {
        text: 'Cust Place',
        align: 'left',
        value: 'custPlace'
      },
      {
        text: 'Name',
        align: 'left',
        value: 'devName',
      },
      {
        text: 'Date Created',
        align: 'left',
        value: 'createdAt',
      },
      {
        text: 'IP Address',
        align: 'left',
        value: 'devAddress'
      },
      {
        text: 'Make',
        align: 'left',
        value: 'devMake'
      },
      {
        text: 'Model',
        align: 'left',
        value: 'devModel'
      },
      {
        text: 'Firmware',
        align: 'left',
        value: 'devFirmware'
      },
      {
        text: 'Device Enabled',
        align: 'left',
        value: 'doorEnabled',
        filter: value => {
          if (!this.filterEnable) return true
          return value == (this.filterEnable == 'true')
        },
      },
      {
        text: 'Device Connected',
        align: 'left',
        value: 'devConnected',
        filter: (value, search, item) => {
          const devFilterDisabled = this.filterConnected.length == this.connectedStates.length;
          const gwFilterDisabled = !this.filterGateways;
          if (devFilterDisabled && gwFilterDisabled) {
            return true
          }
          const gwFilter = item.devGwConnected == (this.filterGateways == 'true');
          if (devFilterDisabled) return gwFilter;
          const found = this.filterConnected.findIndex(str => {
            return str === value;
          })
          const devFilter = found >= 0;
          if( gwFilterDisabled) return devFilter;
          return gwFilter && devFilter;
        },
      },
      {
        text: 'State',
        align: 'left',
        value: 'doorState',
      },
      {
        text: 'Locked',
        align: 'left',
        value: 'doorMode'
      },
      {
        text: 'Alarm',
        align: 'left',
        value: 'doorAlarm'
      },
    ]},
  },

  methods: {
    initialize() {
      this.headers.forEach(header => {
        if (header.align !== " d-none") {
          this.selectedColumns.push(header.value);
        }
      }) 
      this.getDoors();
    },

    getGwColor (connected) {
      if (connected == true) return 'color:black'
      else return 'color:red'
    },

    getDevEnabledColor (gwConn, enabled) {
      let ret = '';
      if (enabled == true) ret = 'color:black'
      else ret = 'color:blue'
      if (!gwConn) {
        ret += ';opacity: 0.3';
      }
      return ret;
    },

    getDevConnectedColor (gwConn, enabled, connected) {
      let ret = '';
      if (enabled == true && connected === "Connected") ret = 'color:green'
      else if (enabled == true && connected === "Connecting") ret = 'color:orange'
      else if (enabled == true && connected === "Disconnected") ret = 'color:red'
      else ret = 'color:blue'
      if (!gwConn) {
        ret += ';opacity: 0.3';
      }
      return ret;
    },

    getStreamColor (connString) {
      // TODO show door status from alarm, mode, state
      if (connString == "Ok") return 'green'
      else if (connString == "Add") return 'blue'
      else if (connString == "Alert") return 'orange'
      else return 'red'
    },

    editColumns() {
      this.showEditColDialog = !this.showEditColDialog;
    },

    changeColumns() {
      this.headers.forEach(header => {
        header.align = " d-none";
      })
      this.selectedColumns.forEach(item => {
        let headerIdx = this.headers.findIndex(obj => {
          return obj.value === item;
        })
        if (headerIdx >= 0) {
          this.headers[headerIdx].align = "left";
        }
      })
    },

    saveSort() {
      sessionStorage.setItem("doorsSortBy", this.sortBy); 
      sessionStorage.setItem("doorsSortDesc", this.sortDesc); 
    },

    saveFilters() {
      if (this.filterGateways?.length) {
        sessionStorage.setItem('doorsGatewayFilter', this.filterGateways);
      } else {
        sessionStorage.setItem('doorsGatewayFilter', "");
      }
      if (this.filterEnable?.length) {
        sessionStorage.setItem('doorsEnableFilter', this.filterEnable);
      } else {
        sessionStorage.setItem('doorsEnableFilter', "");
      }
      if (this.filterConnected?.length) {
        sessionStorage.setItem('doorsConnectedFilter', this.filterConnected);
      } else {
        sessionStorage.setItem('doorsConnectedFilter', "");
      }
    },
    
    exportDoors() {
      console.log("Doors::exportDoors()" + this.name)
      let name = "doors.csv";
      let nameEmpty = (!this.name || 0 === this.name.length);
      if (!nameEmpty) {
        name = this.name + ".csv";
      }
      let exportItems = [];
      let headerString = 'doorID, Gateway, GW Connected, Cust Place, IP Address, Make, Model, Name, Date Created, Firmware, Enabled, Dev Connected, State, Mode, Alarm\n';
      exportItems.push(headerString);
      this.selected.forEach(item => {
        let itemString = item.vsId + ',';
        itemString += item.devGwSerNum + ',';
        itemString += item.devGwConnected ? 'true,' : 'false,';
        itemString += '"' + item.custPlace + '",'; // Name may contain commas
        itemString += item.devAddress + ',';
        itemString += '"' + item.devMake+ '",'; // may contain commas
        itemString += '"' + item.devModel+ '",'; // may contain commas
        itemString += '"' + item.devName + '",'; // Name may contain commas
        itemString += item.createdAt + ',';
        itemString += '"' + item.devFirmware + '",'; // Firmware may contain commas
        itemString += item.doorEnabled + ',';
        itemString += item.devConnected + ',';
        itemString += item.doorState + ','; 
        itemString += item.doorMode + ','; 
        itemString += item.doorAlarm + ','; 
        itemString += '\n'; 
        exportItems.push(itemString);
      });
      let blob = new Blob(exportItems, {
        type: "text/csv"
      });
      saveAs(blob, name);
    },

    prepareDoors() {
      console.log("prepareDoors");
      this.doors = [];
      let id = 0; // ensure camera items have some difference between rows
      for (let device of this.devices) {
        for (let door of device?.doors) {
          // if (device.gateway.connectionStatus == false && this.hideDisconnectedGateways == true) {
          //   break
          // }
          let newDoor = {};
          newDoor.id = id++;
          newDoor.vsId = door?.id;
          newDoor.createdAt = door?.createdAt.split('.')[0];
          newDoor.devAddress = device?.address;
          newDoor.devMake = device?.make;
          newDoor.devModel = device?.model;
          newDoor.devName = device?.doors.length > 1 ? device.name + "::" + door.name : door.name;
          newDoor.devFirmware = device?.firmware;
          newDoor.devGwSerNum = device?.gateway?.serial;
          newDoor.devGwConnected = device?.gateway?.connectionStatus;
          newDoor.devConnected = device?.connectionStatus;
          newDoor.doorEnabled = door.enabled;
          newDoor.custPlace = door?.place?.toHomePlaces?.customerPlace?.name;
          // TODO populate door status from alarm, mode, state
          newDoor.doorAlarm = door?.alarm;
          newDoor.doorMode = door?.mode;
          newDoor.doorState = door?.doorMonitor != "None" ? door?.state : "None";
          // video source defaults
          this.doors.push(newDoor);
        }
      }
    },

    getDoors() {
      console.log('/API/public/systems/doors')
      this.app.restApi({
          method: 'get',
          url: '/API/public/systems/doors',
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          },
          timeout: 5*60*1000

        })
        .then(response => {
          console.log("Success: /API/public/systems/doors");
          this.devices = Object.values(response.data);
          this.prepareDoors();
        })
        .catch( error => {
          console.log(error);
          alert("Failed to get doors from QxControl cloud. error=" + error.response.status)
        });
    },

  }
}
</script>